import { Store } from 'pullstate';

const StatusStore = new Store({
  currentPage: 'Pages',
  actions: {}
});

export default StatusStore;
